export const normalizeSpecialRequestTags = (
  values: ReadonlyArray<string> | null | undefined
) => {
  if (!values || values.length === 0) {
    return [];
  }

  return values.map((value) =>
    value
      .split("_")
      .map((segment) => {
        const lower = segment.toLowerCase();
        return lower.charAt(0).toUpperCase() + lower.slice(1);
      })
      .join(" ")
  );
};
